export enum InsertTableItemDirectionEnum {
    Before,
    After,
}

export enum TablePanelActionIconsEnum {
    HeaderEnabled = '/Content/Images/TableIcons/header_currently_enabled.svg',
    HeaderDisabled = '/Content/Images/TableIcons/header_currently_disabled.svg',
    RowOptions = '/Content/Images/TableIcons/row_options.svg',
    ColumnOptions = '/Content/Images/TableIcons/column_options.svg',
    TableRemove = '/Content/Images/TableIcons/delete_table.svg',
}
